<template>
    <div class="page">
        <p>
            {{ date }}
        </p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ creditor.creditor_name }}
            <br />
            {{ creditor.address_line }}
            <br />
            {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
        </p>
        <p>
            VIA USPS CERTIFIED MAIL/RETURN RECEIPT # [tracking number here]
        </p>
        <p class="letter-content">
            Re:	Dispute of alleged deficiency balance; Account #: {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}
        </p>
        <p>
            Dear {{ creditor.creditor_name }}:
        </p>
        <p>
            You are reporting and attempting to collect an alleged 
            <!--  -->
            <template v-if="lodash.isEmpty(creditor.balance)">
                $[<span style="background-color: #fbff1d;">amount</span>]
            </template>
            <template v-else>
                ${{ creditor.balance }}
            </template>
            
            deficiency balance. Please be advised that I dispute the legal validity of the alleged deficiency balance. Verification of the alleged debt is requested, specifically, a copy of all signed contracts with the original creditor and all legal notices sent on this alleged account. You are attempting to collect a deficiency balance that I am not obligated to pay. Specifically, you have not provided me with the required notices before disposition of collateral and explanation of calculation of deficiency as required under the law. As per the law, cease and desist all collection activity, including all credit reporting. 
            Promptly request deletion of all any credit reporting to credit reporting agencies. Write me to confirm your compliance with my demand within 14 days. This letter is as a complaint to the Consumer Financial Protection Bureau (CFPB). The CFPB is authorized to investigate this issue and receive any related information. If you fail to comply with this letter, I may turn the matter over to an attorney or sue.
        </p>
        <p style="page-break-after: always;">
            Sincerely,
            <br />
            <br/>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            SSN: {{ userStore.user.ssn }}
            <br />
            DOB: {{ userStore.user.dob }}
            <br />
            cc:	Consumer Financial Protection Bureau via fax 1-855-237-2392
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../../../stores/UserStore.js'
    import { useReportStore } from '../../../../stores/ReportStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                lodash: lodash
            };
        }
    };
</script>